/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { BidSubmissionsControllerReadQueryResponse, BidSubmissionsControllerReadPathParams, BidSubmissionsControllerReadQueryParams, BidSubmissionsControllerRead400, BidSubmissionsControllerRead401, BidSubmissionsControllerRead403, BidSubmissionsControllerRead404 } from "../../models/bidsController/BidSubmissionsControllerRead";

function getBidSubmissionsControllerReadUrl(id: BidSubmissionsControllerReadPathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/bid-submissions/${id}` as const }  
  return res
}

/**
 * @summary Read one bid or reply
 * {@link /api/v1/bid-submissions/:id}
 */
export async function bidSubmissionsControllerRead(id: BidSubmissionsControllerReadPathParams["id"], params?: BidSubmissionsControllerReadQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<BidSubmissionsControllerReadQueryResponse, ResponseErrorConfig<BidSubmissionsControllerRead400 | BidSubmissionsControllerRead401 | BidSubmissionsControllerRead403 | BidSubmissionsControllerRead404>, unknown>({ method : "GET", url : getBidSubmissionsControllerReadUrl(id).url.toString(), params, ... requestConfig })  
  return res.data
}